var yellow = 'rgba(209,184,15,1)'
var red = 'rgba(253,67,50,1)'
var blue = 'rgba(0,150,255,1)'
var axisName = '#616266';
var pageBg = 'rgb(28, 29, 33)';
var blackRed = '#91352E';
var darkBlue = '#125E95';
var grey = '#616161';
export {
    yellow,
    red,
    blackRed,
    darkBlue,
    blue,
    axisName,
    pageBg,
    grey
}